import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-622f34d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-relative" }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentScoreChart',
  props: {
    currentScore: { default: 0 },
    potentialScore: { default: 0 },
    pcntScore: { default: 0 },
    isLoading: { type: Boolean },
    noteColor: { default: "#211f58" },
    currentScoreColor: { default: "#48A0FF" },
    totalScoreColor: { default: "#D9EDE2" },
    width: { default: 150 }
  },
  setup(__props: any) {

const props = __props;



const optionsCurrent = computed(() => ({
  colors: [props.currentScoreColor],
  plotOptions: {
    radialBar: {
      startAngle: -90,
      endAngle: 90,
      hollow: {
        size: "75%",
      },
      track: {
        strokeWidth: "90%",
        background: props.totalScoreColor,
        opacity: 1,
        show: true,
      },
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          show: true,
          color: props.currentScoreColor,
          fontSize: "20px",
          fontWeight: 500,
          fontFamily: "Poppins",
          offsetY: 5,
          offsetX: 3,
          formatter: () => `${Math.round(props.pcntScore * 100)}%`,
        },
      },
    },
  },
  stroke: {
    show: true,
    lineCap: "round",
    opacity: 1,
  },
  fill: {
    opacity: 1,
  },
  labels: ["current"],
}));

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_apexchart, {
      class: _normalizeClass('score-chart-short'),
      style: ``,
      width: _ctx.width,
      type: "radialBar",
      options: optionsCurrent.value,
      series: [_ctx.currentScore * 100]
    }, null, 8, ["width", "options", "series"])
  ]))
}
}

})